"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var A = __importStar(require("fp-ts/Array"));
var O = __importStar(require("fp-ts/Option"));
var S = __importStar(require("fp-ts/Semigroup"));
var function_1 = require("fp-ts/function");
var function_2 = require("fp-ts/function");
var React = __importStar(require("react"));
require("./carousel.css");
var TABLET_RESPONSIVE_THRESHOLD = 768;
var DESKTOP_SCREEN_THRESHOLD = 1024;
var HD_DESKTOP_SCREEN_THRESHOLD = 1600;
var getMapValue = function () {
    return [
        {
            range: (0, function_1.tuple)(0, TABLET_RESPONSIVE_THRESHOLD),
            key: 'xs',
        },
        {
            range: (0, function_1.tuple)(TABLET_RESPONSIVE_THRESHOLD, DESKTOP_SCREEN_THRESHOLD),
            key: 'md',
        },
        {
            range: (0, function_1.tuple)(DESKTOP_SCREEN_THRESHOLD, HD_DESKTOP_SCREEN_THRESHOLD),
            key: 'lg',
        },
        {
            range: (0, function_1.tuple)(HD_DESKTOP_SCREEN_THRESHOLD, 10000000000),
            key: 'xl',
        },
    ];
};
var Carousel = function (props) {
    var _a = React.useState({
        value: 0,
    }), currentWidth = _a[0], setCurrentWidth = _a[1];
    function findBySlug(slug) {
        if (typeof slug === 'undefined') {
            return 0;
        }
        return props.slides.findIndex(function (item) { return item.slug === slug; });
    }
    var _b = React.useState({
        currentSlideIndex: findBySlug(props.showFirstCardSlug),
        startValue: 0,
        currentValue: 0,
        dragging: false,
    }), state = _b[0], setState = _b[1];
    var _c = React.useState({ timerId: 0 }), timerId = _c[0], setTimerId = _c[1];
    React.useEffect(function () {
        setWidth();
        window.addEventListener('load', setWidth);
        window.addEventListener('resize', resetWidth);
        var timeout = function () {
            setTimerId({
                timerId: window.setTimeout(function () {
                    nextSlide();
                    timeout();
                }, props.changeOnTime),
            });
        };
        if (props.changeOnTime) {
            timeout();
        }
        return function () {
            window.removeEventListener('load', setWidth);
            window.removeEventListener('resize', resetWidth);
            clearTimeout(timerId.timerId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var getId = React.useMemo(function () { return "carousel_".concat(props.slides.length, "_").concat(props.slides.map(function (s) { return s.slug; }).join('_')); }, [props.slides]);
    var isTypeCards = function (p) {
        return p.type === 'cards';
    };
    var cardsInForeground = function () {
        if (!isTypeCards(props)) {
            return 1;
        }
        var width = document.documentElement.clientWidth;
        return (0, function_2.pipe)(getMapValue(), A.findFirst(function (_a) {
            var _b = _a.range, lower = _b[0], upper = _b[1];
            return width > lower && width <= upper;
        }), O.chain(function (m) { return O.fromNullable(props.foregroundCards[m.key]); }), O.getOrElse(function () { return 1; }));
    };
    var stepCount = function () {
        switch (props.type) {
            case 'default':
                return props.slides.length;
            case 'cards':
                return props.slides.length - cardsInForeground() + 1;
        }
    };
    var nextSlide = function () {
        var nextSlideIndex = state.currentSlideIndex < stepCount() - 1 ? state.currentSlideIndex + 1 : 0;
        setState(__assign(__assign({}, state), { currentSlideIndex: nextSlideIndex }));
        handleSlideChange(props.slides[nextSlideIndex].slug);
    };
    var slideTo = function (to) {
        window.requestAnimationFrame(function () {
            setState(__assign(__assign({}, state), { currentSlideIndex: to }));
            handleSlideChange(props.slides[to].slug);
        });
    };
    var onTouchMove = function (e) {
        return setState(__assign(__assign({}, state), { currentValue: e.changedTouches['0'].clientX }));
    };
    var handleSlideChange = function (slug) {
        if (props.onSlideChange) {
            props.onSlideChange(slug);
        }
    };
    var setWidth = function () {
        var w = document.getElementById(getId).offsetWidth;
        if (currentWidth.value !== w) {
            setCurrentWidth({ value: w });
        }
    };
    var resetWidth = function () {
        setCurrentWidth({ value: 0 });
        setWidth();
    };
    var onTouchStart = function (e) {
        return (0, function_2.pipe)(O.fromNullable(state.dragging), O.filter(function (drag) { return drag === false; }), O.map(function (_) {
            setState(__assign(__assign({}, state), { dragging: true, startValue: e.changedTouches['0'].clientX }));
        }), O.toUndefined);
    };
    var calculateStep = function (direction) {
        return (0, function_2.pipe)(direction === 'left' ? -1 : 1, function (add) { return state.currentSlideIndex + add; }, function (x) { return Math.max(Math.min(x, stepCount() - 1), 0); });
    };
    var triggerSlide = function (current) {
        var swipeSpan = state.startValue - current;
        return (0, function_2.pipe)(O.getMonoid(S.first()).concat((0, function_2.pipe)(O.fromPredicate(function (ss) { return ss >= 40; })(swipeSpan), O.map(function (_) { return calculateStep('right'); })), (0, function_2.pipe)(O.fromPredicate(function (ss) { return ss <= -40; })(swipeSpan), O.map(function (_) { return calculateStep('left'); }))), O.getOrElse(function () { return state.currentSlideIndex; }));
    };
    var onEventEnd = function () {
        return (0, function_2.pipe)(O.some(state.currentValue), O.match(function () { return setState(__assign(__assign({}, state), { dragging: false })); }, function (current) {
            return setState(__assign(__assign({}, state), { dragging: false, currentSlideIndex: triggerSlide(current) }));
        }));
    };
    var cssForDefaultTransaltion = function (carouselContainerWidth, numberOfChildren, goToIndex) {
        var translateAmountPercentage = "".concat(-1 * goToIndex * carouselContainerWidth, "px");
        return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            transform: translateX(", ");\n            width: ", "px;\n            display: ", ";\n        "], ["\n            transform: translateX(", ");\n            width: ", "px;\n            display: ", ";\n        "])), translateAmountPercentage, carouselContainerWidth * numberOfChildren, carouselContainerWidth === 0 ? 'none' : 'block');
    };
    var cssForCardsTransaltion = function (carouselContainerWidth, numberOfCards, goToIndex) {
        return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            transform: translateX(", "%);\n            width: ", "px;\n            display: ", ";\n        "], ["\n            transform: translateX(", "%);\n            width: ", "px;\n            display: ", ";\n        "])), (goToIndex / numberOfCards) * -100, carouselContainerWidth * numberOfCards, carouselContainerWidth === 0 ? 'none' : 'flex');
    };
    var cssForTranslation = function () {
        switch (props.type) {
            case 'default':
                return cssForDefaultTransaltion(currentWidth.value, props.slides.length, state.currentSlideIndex);
            case 'cards':
                return cssForCardsTransaltion(currentWidth.value, props.slides.length, allCardsAreDisplaying ? 0 : state.currentSlideIndex);
        }
    };
    var renderArrow = function (direction) {
        return allCardsAreDisplaying || (direction === 'left' ? isLeftMostPosition() : isRightMostPosition()) ? null : ((0, jsx_runtime_1.jsx)("div", { className: "arrow ".concat(direction, "-arrow icon_arrow_").concat(direction, "_dark"), onClick: function () { return (0, function_2.pipe)(calculateStep(direction), slideTo); } }));
    };
    var calculateCardWidth = function () {
        if (props.type === 'default') {
            return currentWidth.value;
        }
        var viewportWidth = document.documentElement.clientWidth;
        return (currentWidth.value - viewportWidth * 0.1) / cardsInForeground();
    };
    var renderSlides = function () {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('carousel-slides', props.type === 'cards' ? 'type-cards' : undefined, !('ontouchstart' in document.documentElement) ? 'no-touch' : undefined), css: cssForTranslation() }, { children: props.slides.map(function (c) { return ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, clsx_1.default)('carousel-slide', props.type === 'cards' ? 'type-cards' : undefined), css: (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                            width: ", "px;\n                        "], ["\n                            width: ", "px;\n                        "])), calculateCardWidth()) }, { children: c.slide }), c.slug)); }) })));
    };
    var renderCarousel = function () {
        if (props.type === 'cards') {
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [renderArrow('left'), (0, jsx_runtime_1.jsx)("div", __assign({ className: "central-with-arrows", onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onEventEnd }, { children: renderSlides() })), renderArrow('right')] }));
        }
        return renderSlides();
    };
    var allCardsAreDisplaying = props.slides.length === cardsInForeground();
    var isLeftMostPosition = function () { return state.currentSlideIndex === 0; };
    var isRightMostPosition = function () { return state.currentSlideIndex === stepCount() - 1; };
    return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('carousel', props.type === 'cards' ? 'type-cards' : undefined), id: getId }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('carousel-container', props.type === 'cards' ? 'type-cards' : undefined), css: (0, react_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                        width: ", "px;\n                    "], ["\n                        width: ", "px;\n                    "])), currentWidth.value) }, { children: renderCarousel() })), allCardsAreDisplaying ? null : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "carousel-pointer-container" }, { children: (0, function_2.pipe)(props.slides, A.takeLeft(stepCount()), function (c) {
                        return c.map(function (_, i) { return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(!('ontouchstart' in document.documentElement) ? 'no-touch' : undefined, 'carousel-pointer', { selected: i === state.currentSlideIndex }), onClick: function () { return slideTo(i); } }, i)); });
                    }) })))] })) }));
};
exports.Carousel = Carousel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Carousel.js.map